import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../contexts/ThemeContext";
import "./styles/navBar.css";

const NAV_ITEMS = [
	{ path: "/", label: "Home" },
	{ path: "/projects", label: "Projects" },
	{ path: "/research", label: "Research" },
	{ path: "/interests", label: "Interests" },
	{ path: "/experience", label: "Work" },
	{ path: "/contact", label: "Contact" },
];

const NavBar = () => {
	const location = useLocation();
	const { theme, toggleTheme } = useTheme();
	const [scrolled, setScrolled] = useState(false);
	const [mobileOpen, setMobileOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	useEffect(() => {
		setMobileOpen(false);
	}, [location]);

	useEffect(() => {
		document.body.style.overflow = mobileOpen ? "hidden" : "";
		return () => { document.body.style.overflow = ""; };
	}, [mobileOpen]);

	return (
		<div className={`nav-container ${scrolled ? "nav-scrolled" : ""}`}>
			<nav className="navbar">
				<Link to="/" className="nav-logo">
					<span className="nav-logo__mark">BS</span>
				</Link>

				<ul className="nav-list">
					{NAV_ITEMS.map((item) => (
						<li
							key={item.path}
							className={`nav-item ${location.pathname === item.path ? "active" : ""}`}
						>
							<Link to={item.path}>{item.label}</Link>
						</li>
					))}
				</ul>

				<div className="nav-right">
					<button
						className="nav-theme-toggle"
						onClick={toggleTheme}
						aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
					>
						{theme === "dark" ? "Light" : "Dark"}
					</button>

					<button
						className="nav-hamburger"
						onClick={() => setMobileOpen(!mobileOpen)}
						aria-label="Toggle menu"
					>
						<FontAwesomeIcon icon={mobileOpen ? faXmark : faBars} />
					</button>
				</div>
			</nav>

			<div
				className={`nav-mobile-overlay ${mobileOpen ? "open" : ""}`}
				onClick={() => setMobileOpen(false)}
			>
				<div
					className={`nav-mobile-menu ${mobileOpen ? "open" : ""}`}
					onClick={(e) => e.stopPropagation()}
				>
					<button
						className="nav-mobile-close"
						onClick={() => setMobileOpen(false)}
						aria-label="Close menu"
					>
						<FontAwesomeIcon icon={faXmark} />
					</button>
					{NAV_ITEMS.map((item, i) => (
						<Link
							key={item.path}
							to={item.path}
							className={`nav-mobile-item ${location.pathname === item.path ? "active" : ""}`}
							style={{ transitionDelay: mobileOpen ? `${i * 0.04}s` : "0s" }}
						>
							{item.label}
						</Link>
					))}
					<button
						className="nav-mobile-theme"
						onClick={toggleTheme}
						style={{ transitionDelay: mobileOpen ? `${NAV_ITEMS.length * 0.04}s` : "0s" }}
					>
						{theme === "dark" ? "Light mode" : "Dark mode"}
					</button>
				</div>
			</div>
		</div>
	);
};

export default NavBar;
